import renderHistoryCardsBlock from '../actions/renderHistoryCardsBlock';

/**
 * History Cards block
 */
const HistoryCardsBlock =( $ )=>{

	if ( $( 'body' ).hasClass( 'page-template-history-index' ) ) {
		renderHistoryCardsBlock();
	}

};

export default HistoryCardsBlock;
